import { render, staticRenderFns } from "./Detail-adjustment.vue?vue&type=template&id=fc0e28fa&"
import script from "./Detail-adjustment.vue?vue&type=script&lang=js&"
export * from "./Detail-adjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports